<a mat-list-item class="menu-item" [routerLink]="route" routerLinkActive="selected-menu-item" #rla="routerLinkActive"
    [activated]="rla.isActive">
    <mat-icon [fontSet]="rla.isActive ? 'material-icons' : 'material-icons-outlined'" matListItemIcon>
        {{ icon }}
    </mat-icon>
    @if(!collapsed()) {
    <p matListItemTitle>{{ translationKey | translate }}</p>
    }
</a>